import { useEngineStore } from '../stores/use-engine-store'
import { SenderRole, type UIMessage } from '../types/chat-model'
import { Markdown } from './markdown'
import { GalgameTools } from './galgame-tools'
import { MessageChoices } from './message-choices'

interface TextMessageRenderProps {
  message: UIMessage
  sessionId: string
}

export default function TextGalgameRender({ message, sessionId }: TextMessageRenderProps) {
  const { galgameState, choice } = useEngineStore()

  const { galgameSegments, galgameIndex } = galgameState
  const { currentEngine } = useEngineStore((s) => s.engine)
  const messages = useEngineStore((s) => s.messages.messages) || []
  const isLastMessage = galgameState.currentMessageIndex === messages.length - 1

  const currentSegment = galgameSegments[galgameIndex] || ''
  const isLastSegment = galgameIndex === galgameSegments.length - 1


  // 角色名逻辑
  const characterName = message.role === SenderRole.USER ? '我' : currentEngine?.title

  return (
    <div className='relative w-full'>
      {/* 选项区域 - 悬浮在对话框上方层级，只在最后一条消息时显示 */}
      {isLastMessage && isLastSegment && !choice.isPolling && (
        <div className='absolute bottom-3/4 left-1/2 z-50 -translate-x-1/2 px-4 w-full'>
          {message.choices && message.choices.length > 0 ? (
            <MessageChoices
              choices={message.choices}
              mode='galgame'
              className='animate-in fade-in slide-in-from-bottom-4 duration-500'
            />
          ) : (
            <div className='text-center text-accent animate-in fade-in duration-500'>
              当前消息无选项，请进入聊天模式手动输入消息进行对话
            </div>
          )}
        </div>
      )}

      {/* 沉浸式全屏宽度对话区域：由下往上透明度变低 */}
      <div className='w-full bg-linear-to-t from-black/95 via-black/70 via-40% to-transparent px-6 pt-24 pb-4 md:px-16 md:pt-32 md:pb-6 lg:px-24'>
        <div className='mx-auto max-w-7xl'>
          {/* 文字内容（在上方展示） */}
          <div className='min-h-[110px] md:min-h-[150px]'>
            {/* 角色名称（仿【姓名】样式） */}
            <div className='mb-3 md:mb-5'>
              <span className='text-lg font-bold tracking-widest text-white drop-shadow-[0_2px_4px_rgba(0,0,0,0.8)] md:text-2xl'>
                【{characterName}】
              </span>
            </div>

            {/* 消息正文 */}
            <div className='font-serif text-[18px] leading-relaxed tracking-wide text-white/95 drop-shadow-md md:text-[23px]'>
              <Markdown>{currentSegment}</Markdown>
            </div>
          </div>

          {/* 工具栏（进入普通文档流，靠右下角） */}
          <div className='mt-2 flex justify-end items-center'>
            <GalgameTools sessionId={sessionId} />
          </div>
        </div>
      </div>
    </div>
  )
}
